import { IdcardOutlined, MailOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { CHAT_INPUT_MODES } from '@guuru/chat-web';

const INPUT_MODE_ICONS = {
  [CHAT_INPUT_MODES.name]: IdcardOutlined,
  [CHAT_INPUT_MODES.email]: MailOutlined,
};

const LeftIcon = function ({ inputMode = null }) {
  const Icon = INPUT_MODE_ICONS[inputMode] || null;
  return Icon && <Icon style={{ color: '#737376', marginRight: '8px' }} />;
};

LeftIcon.propTypes = {
  inputMode: PropTypes.string,
};

export default LeftIcon;
